// theme/scripts/components/collar.js

import axios from 'axios';
import React, { useState, useEffect, useContext, useRef } from 'react';
import SelectComponent from '../common/select';
import OptionComponent from '../common/option';
import { CustomizeContext } from '../contexts/customize';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/get_collarshaped',
});

const productId = document.getElementById('mtm-customize')?.dataset?.productId ?? '';

const MtmCollar = () => {
  const [list, setList] = useState([]);
  const [error, setError] = useState(null);
  const { customizes, setCustomizes } = useContext(CustomizeContext);
  const reorderRef = useRef(null);
  const matchedCollarRef = useRef(null);
  const matchedTypeRef = useRef(null);

  const eq = (a, b) =>
    String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

  // 📦 reorder情報をロード
  useEffect(() => {
    try {
      const reorderRaw = sessionStorage.getItem('reorder_properties');
      if (reorderRaw) {
        reorderRef.current = JSON.parse(reorderRaw);
      }
    } catch (err) {
      console.warn('⚠️ reorder_properties parse error:', err);
      reorderRef.current = null;
    }
  }, []);

  // 🎯 collar一覧取得 + reorder反映
  useEffect(() => {
    let mounted = true;

    const fetchCollarList = async () => {
      try {
        const response = await client.get(`?product_id=${productId}`);
        if (!mounted) return;

        const collarList = response.data.result || [];
        setList(collarList);

        const reorderData = reorderRef.current;
        if (!reorderData) return;

        const reorderLabel = reorderData._Collar?.trim();
        const reorderType = reorderData._Cleric_Type?.trim();

        // 対応するcollarを特定
        const matchedCollar = collarList.find(
          (item) => eq(item.label, reorderLabel) || eq(item.value, reorderLabel)
        );
        if (!matchedCollar) {
          setError(`⚠️ Reorder: "${reorderLabel}" not found in this fabric.`);
          return;
        }

        // cleric_typeマッチング
        const matchedType =
          matchedCollar.cleric_type?.find(
            (t) => eq(t.label, reorderType) || eq(t.value, reorderType)
          ) || null;

        matchedCollarRef.current = matchedCollar;
        matchedTypeRef.current = matchedType;

        // Context更新
        setCustomizes((prev) => ({
          ...prev,
          collar: {
            ...prev.collar,
            id: matchedCollar.id,
            label: matchedCollar.label,
            value: matchedCollar.value,
            img: matchedCollar.image_url,
            cleric_type:  matchedType
              ? {
                  id: matchedType.id,
                  label: matchedType.label,
                  value: matchedType.value,
                }
              : null,
          },
        }));
      } catch (err) {
        console.error('❌ collar API error:', err);
        if (mounted) {
          setError('❌ カラー情報の取得中にエラーが発生しました。');
        }
      }
    };

    fetchCollarList();

    return () => {
      mounted = false;
    };
  }, []);

  // 🧱 レンダリング
  if (!list.length) return null;

  return (
    <div className="mtm-item__wrapper active" id="mtm-collar">
      <h3 className="mtm-item__title">COLLAR</h3>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <div className="mtm-item__selects row row-cols-2 row-cols-md-4">
        {list.map((item, ind) => (
          <SelectComponent
            key={`${item.value}-${ind}`}
            item={item}
            ind={ind}
            name="collar"
            option_type={item.cleric_type?.length || 0}
          />
        ))}
      </div>

      <div className="mtm-item__options" id="mtm-collar__option">
        {list.map((item, ind) => {
          const isActive = customizes?.collar?.value === item.value;
          return (
            <div
              className={`options-item mtm-item__selects row${isActive ? ' active' : ''}`}
              data-collars={item.value}
              key={`collars-sel-${ind}`}
            >
              {Array.isArray(item.cleric_type) && item.cleric_type.length > 0 ? (
                item.cleric_type.map((cleric, subInd) => (
                  <OptionComponent
                    key={`cleric-${item.id}-${subInd}-${customizes?.collar?.id || 'reset'}`}
                    cleric={cleric}
                    ind={subInd}
                    parent="collar"
                    name="cleric_type"
                  />
                ))
              ) : (
                <p className="no-option-message" style={{ color: '#999', fontSize: '12px' }}>
                  No selectable cleric types for this option.
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MtmCollar;
